export const QueryDefaults = {
    StaleTime: 10 * 60 * 1000, // 10 minutes
} as const;
